import { AssetType } from '../../api/models/Shared.types';
import { VodDetailDataSource } from './vod/VodDetailDataSource';
import { BundleDetailDataSource } from './bundle/BundleDetailDataSource';
import { ProgramDetailDataSource } from './epg/ProgramDetailDataSource';
import { RecordingDetailDataSource } from './epg/RecordingDetailDataSource';
import { ScheduleDetailDataSource } from './epg/ScheduleDetailDataSource';
import { ChannelDetailDataSource } from './epg/ChannelDetailDataSource';
import { SeriesDetailDataSource } from './epg/SeriesDetailDataSource';
import { Backend } from '../../api/Backend';
import { DetailDataSource } from './DetailDataSource';
import { Utils } from '@lightningjs/sdk';

export function getDetailDataSource(backend: Backend, type: AssetType): DetailDataSource {
  switch (type) {
    case AssetType.VOD:
      return new VodDetailDataSource(backend);
    case AssetType.SERIES:
      return new SeriesDetailDataSource(backend);
    case AssetType.SCHEDULE:
      return new ScheduleDetailDataSource(backend);
    case AssetType.CHANNEL:
      return new ChannelDetailDataSource(backend);
    case AssetType.RECORDING:
      return new RecordingDetailDataSource(backend);
    case AssetType.PROGRAM:
      return new ProgramDetailDataSource(backend);
    case AssetType.BUNDLE:
      return new BundleDetailDataSource(backend);
    // case AssetType.ARTICLE:
    default:
      throw new Error('Unrecognized or unsupported AssetType');
  }
}

/**
 * get the icon matching the rating provided or undefined if there is none
 */
export function getAgeratingIcon(rating: number | undefined) {
  if (rating === 0 || rating === undefined) {
    return undefined;
  }
  if (rating <= 4) {
    return Utils.asset('/images/agerating/age4.png');
  }
  if (rating <= 6) {
    return Utils.asset('images/agerating/age6.png');
  }
  if (rating <= 12) {
    return Utils.asset('images/agerating/age12.png');
  }
  if (rating <= 14) {
    return Utils.asset('images/agerating/age14.png');
  }
  if (rating <= 16) {
    return Utils.asset('images/agerating/age16.png');
  }
  if (rating <= 18) {
    return Utils.asset('images/agerating/age18.png');
  }
  return undefined;
}
